declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const sendGAEvent = (event: string, params?: Record<string, any>) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
};